import ItemApi from '@apis/item/ItemApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';

const itemQueries = createQueryKeys('items', {
    list: (shopId: string, categoryId: string) => ({
        queryKey: [shopId, categoryId],
        queryFn: () => ItemApi.getItems(shopId, categoryId),
    }),
    detail: (itemId: string) => ({
        queryKey: [itemId],
        queryFn: () => ItemApi.getItem(itemId),
    }),
    nutrition: (itemId: string) => ({
        queryKey: [itemId, 'nutrition'],
        queryFn: () => ItemApi.getNutrition(itemId),
    }),
    shopItemFromShop: (shopId: string, itemId: string) => ({
        queryKey: ['fromShop', shopId, itemId],
        queryFn: () => ItemApi.getShopItemFromItemId(shopId, itemId),
    }),
});

export default itemQueries;
